var map = {
	"./hobby/backcountry_skiing.jpeg": "6fd0",
	"./hobby/camping.jpg": "c7a6",
	"./hobby/climbing.jpg": "db17",
	"./hobby/kims_logo.svg": "7c56",
	"./hobby/kims_tuebingen.jpeg": "6cc6",
	"./hobby/tema.jpeg": "84e8",
	"./projects/blog3.jpg": "4cf4",
	"./projects/blog4.jpg": "918a",
	"./projects/iss_space.jpg": "1577",
	"./projects/iss_world.jpg": "fa02",
	"./wedding/freistil.jpeg": "2a8c",
	"./wedding/save_date.png": "e27c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";